import * as d3 from 'd3'
export default {
  
  methods: {

    table_Header() {

      let tbl = this.table

      let tblCanvas = this.canvasForm
      .append('g')
      .attr('transform', `translate(${tbl.x}, ${tbl.y})`)

      this.gmx_Line(tblCanvas, 0, tbl.width, 0, 0, '#757575', .5, 1)
      this.gmx_Line(tblCanvas, 0, tbl.width, tbl.height, tbl.height, '#757575', .5, 1)

      tbl.columns.forEach(col=> {
        tblCanvas
        .append('text')
        .attr('x', col.mx)
        .attr('y', col.group=='Y' ? this.table.depth[1] : this.table.depth[2])
        .attr('font-size', col.tSize)
        .attr('fill', col.group=='Y' ? '#000' : '#757575')
        .attr('text-anchor', 'middle')
        .text(col.name)
      })
      
      tbl.colspan.forEach((col, c)=> {
        let x_ = tbl.columns[col.start].sx + (tbl.columns[col.finish].ex - tbl.columns[col.start].sx)/2
        this.gmx_Text(tblCanvas, '', x_, tbl.depth[0], col.tSize, col.tColor, 'middle', '', col.name)
        this.gmx_Line(tblCanvas, tbl.columns[col.start].sx, tbl.columns[col.finish].ex, tbl.height-13, tbl.height-13, '#bcbcbc', .5, 1)
      })

      this.draw_Table(tblCanvas)
    },


    draw_Table(selection) {

      let tbl = this.table
      let y_ = 43

      this.rawData.filter(f=> f.DISC !== 'Overall').forEach(d=> {

        let item = selection
        .append('g')
        .attr('transform', `translate(0, ${y_})`)
        .attr('cursor', 'pointer')
        .call(this.call_Pie_Event, d)

        item
        .append('rect')
        .attr('id', `TBL_${d.DISC}_${this.localId}`)
        .attr('x', 0).attr('y', -12)
        .attr('width', tbl.width).attr('height', this.table.lineHeight)
        .attr('fill', '#F4F5F5').attr('opacity', 0)

        tbl.columns.forEach(col=> {
          item
          .append('text')
          .attr('x', col.tx).attr('y',  0)
          .attr('font-size', 10)
          .attr('fill', col.code=='DELTA' ? this.gmx_deltaValue(d[col.code]) : col.tColor)
          .attr('text-anchor', col.align)
          .text(col.unit=='%' ? d[col.code].toFixed(1) + '%' : d[col.code])
        })

        y_ = y_ + this.table.lineHeight
      })

      y_ = y_ + 2

      let total = this.rawData.find(f=> f.DISC == 'Overall')
  
      let keys = Object.keys(total)
      let lastIndex = Object.keys(total).reduce((acc, key, index) => total[key] == 'Overall' ? index : acc, -1)

      let voX = (tbl.columns[lastIndex].ex - tbl.columns[0].sx)/2

      this.gmx_Line(selection, 0, tbl.width, y_-13, y_-13, '#757575', .5, 1)
      this.gmx_Line(selection, 0, tbl.width, y_+5, y_+5, '#757575', .5, 1)
      this.gmx_Text(selection, '', voX, y_, 11, '#000', 'middle', '', 'Overall')

      tbl.columns.forEach((col,c)=> {
        if(c<2 || !total[col.code]) return
        selection
        .append('text')
        .attr('x', col.tx).attr('y',  y_)
        .attr('font-size', 10)
        .attr('fill', col.code=='DELTA' ? this.gmx_deltaValue(total[col.code]) : '#000')
        .attr('text-anchor', col.align)
        .text(col.unit=='%' ? total[col.code].toFixed(1) + '%' : total[col.code])
      })
    },

  }
}